// ========================================
// HEAL N PRETTY - THEME JAVASCRIPT
// ========================================

// Cart functionality
document.addEventListener('DOMContentLoaded', function() {
  // Update cart count
  updateCartCount();
  
  // Smooth scroll for anchor links
  setupSmoothScroll();
  
  // Image gallery
  setupImageGallery();
  
  // Quantity buttons
  setupQuantityButtons();
});

// Update cart count in header
function updateCartCount() {
  fetch('/cart.json')
    .then(response => response.json())
    .then(data => {
      const cartCount = document.querySelector('.cart-count');
      if (cartCount) {
        cartCount.textContent = data.item_count;
      }
    })
    .catch(error => console.error('Error fetching cart:', error));
}

// Smooth scroll for anchor links
function setupSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
}

// Product image gallery
function setupImageGallery() {
  const images = document.querySelectorAll('.product-gallery img');
  const mainImage = document.querySelector('.product-main-image');
  
  images.forEach(img => {
    img.addEventListener('click', function() {
      if (mainImage) {
        mainImage.src = this.src;
        mainImage.style.opacity = '0';
        setTimeout(() => {
          mainImage.style.opacity = '1';
        }, 50);
      }
      
      // Update active state
      images.forEach(i => i.style.opacity = '0.7');
      this.style.opacity = '1';
    });
  });
}

// Quantity button handlers
function setupQuantityButtons() {
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const input = this.parentElement.querySelector('input[name="quantity"]');
      const action = this.dataset.action;
      let value = parseInt(input.value);
      
      if (action === 'increase') {
        input.value = value + 1;
      } else if (action === 'decrease' && value > 1) {
        input.value = value - 1;
      }
    });
  });
}

// Add to cart with toast notification
function addToCart(formData) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
    updateCartCount();
    showToast('Added to bag!');
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    showToast('Error adding to bag', 'error');
  });
}

// Toast notification
function showToast(message, type = 'success') {
  const toast = document.createElement('div');
  toast.textContent = message;
  toast.style.cssText = `
    position: fixed;
    bottom: 20px;
    right: 20px;
    background-color: ${type === 'success' ? '#4A3F5C' : '#ff6b6b'};
    color: white;
    padding: 16px 24px;
    border-radius: 4px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    z-index: 1000;
    animation: slideIn 300ms ease-out;
  `;
  
  document.body.appendChild(toast);
  
  setTimeout(() => {
    toast.style.animation = 'slideOut 300ms ease-out';
    setTimeout(() => toast.remove(), 300);
  }, 3000);
}

// Add CSS animations
const style = document.createElement('style');
style.textContent = `
  @keyframes slideIn {
    from {
      transform: translateX(400px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
  
  @keyframes slideOut {
    from {
      transform: translateX(0);
      opacity: 1;
    }
    to {
      transform: translateX(400px);
      opacity: 0;
    }
  }
`;
document.head.appendChild(style);
